import BusinessIcon from 'src/images/businessIcon.png';
import AddressIcon from 'src/images/address.png';
import TimeIcon from 'src/images/time.png';
import PersonIcon from 'src/images/profile.png';
import PhoneIcon from 'src/images/phone.png';
import moment from "moment";
import OrderNotes from 'src/components/Order/OrderDetails/OrderNotes';
import DeliveryNote from './DeliveryNote';
import UrlIcon from 'src/images/url.svg';
import { useMemo } from 'react';
import { getPhoneHref } from 'src/helper/global';

const OrderStatus = {
  PICKUP: 'Pick up from:',
  DELIVERY: 'Delivery to:'
}
const OrderTimeStatus = {
  PICKUP: 'Pickup time:',
  DELIVERY: 'Delivery time:'
}
const OrderDetails = ({orderData, timeZoneId}) => {

  const trackrUrl = useMemo(() => {
    const businessId = orderData?.business[0]?._id || orderData?.business[0]?.id || '';
    return `${process.env.REACT_APP_TRACKR_URL}?oUuid=${orderData?.uuid}&bid=${businessId}&bUuid=${orderData?.business[0]?.uuid}`
  }, [orderData]);

  const phoneHref = getPhoneHref(orderData?.contactInfo?.phone);

  return (
    <div className="order-details">
      <p className="order-details-title">Order details:</p>
      {orderData?.business[0]?.settings?.addressInfoVisible && (
        <div className="order-details-business">
          <div>
            <img src={BusinessIcon} alt="business-icon"/>
          </div>
          <div className="order-details-address">
            <p
              className="order-details-address-name">{orderData.business[0]?.companyName || orderData.business[0]?.title}</p>
            <p className="order-details-address-currentAddress">{orderData.business[0]?.addressInfo?.fullAddress}</p>
          </div>
        </div>
      )}
      <div className="order-details-business">
        {orderData.type === 'pickup' ? (
          <>
            <div>
              <img src={AddressIcon} alt="address-icon"/>
            </div>
            <div className="order-details-address">
              <p className="order-details-address-name">{OrderStatus[orderData.type.toUpperCase()]}</p>
              <p className="order-details-address-currentAddress">
                <>
                  {orderData.business[0]?.addressInfo?.fullAddress}
                </>
              </p>
            </div>
          </>
        ) : (
          <>
            <div>
              <img src={AddressIcon} alt="address-icon"/>
            </div>
            <div className="order-details-address">
              <p className="order-details-address-name">{OrderStatus[orderData.type.toUpperCase()]}</p>
              <p className="order-details-address-currentAddress">
                <>
                  {orderData.deliveryInfo?.addressInfo?.fullAddress}
                </>
              </p>
            </div>
          </>
        )}
      </div>
      
       
      {orderData?.delivery?.deliveryInstructions && (
       <DeliveryNote deliveryNote={orderData?.delivery?.deliveryInstructions} />
      )}
      <div className="order-details-business">
        <div>
          <img src={TimeIcon} alt="time-icon"/>
        </div>
        <div className="order-details-address">
          <p className="order-details-address-name">Be ready:</p>
          <p className="order-details-address-currentAddress">
            {moment(orderData?.beReadyTime)?.tz(timeZoneId)
              .format("hh:mm A - ddd, MMM Do")}
          </p>
        </div>
      </div>
      {orderData.type === 'delivery' && (
        <div className="order-details-business">
          <div>
            <img src={UrlIcon} alt="url-icon" />
          </div>
          <p className="order-details-address-currentAddress" style={{ marginTop: '0px', color: '#FF8A00' }}>
            <a href={trackrUrl} style={{ color: '#FF8A00', fontWeight: 600 }} target="_blank" rel="noopener noreferrer">Tracking URL</a>
          </p>
        </div>
      )}
      {orderData?.contactInfo?.name && (
        <div className="order-details-business">
          <div>
            <img src={PersonIcon} alt="person-icon"/>
          </div>
          <div className="order-details-address">
            <p className="order-details-address-name">Customer Name:</p>
            <p className="order-details-address-name">{orderData?.contactInfo?.name}</p>
          </div>
        </div>
      )}
      {orderData?.contactInfo?.phone && (
        <div className="order-details-business">
          <div>
            <img src={PhoneIcon} alt="phone-icon"/>
          </div>
          <div className="order-details-address">
            <p className="order-details-address-name">Phone Number:</p>
            <p className="order-details-address-name">
              {phoneHref ? (
                <a href={phoneHref} style={{ color: '#0066cc', textDecoration: 'underline' }}>
                  {orderData?.contactInfo?.phone}
                </a>
              ) : (
                orderData?.contactInfo?.phone
              )}
            </p>
          </div>
        </div>
      )}
      <hr className="line-header"/>
       {orderData?.specialInstructions && (
        <OrderNotes specialInstructions={orderData?.specialInstructions} />
      )}
    </div>
  )
}
export default OrderDetails